<template>
  <div
    class="m-mobile-nav__item"
    :class="{
      'm-mobile-nav__item--button': isButton,
      'm-mobile-nav__item--active': active,
    }"
  >
    <component
      :is="tag"
      v-if="!isButton"
      :class="{ 'm-mobile-nav__link': !isButton }"
      v-bind="attrs"
    >
      <slot />
    </component>

    <slot v-else />
  </div>
</template>

<script>
import { clickableTag } from '../../../lib/type-validators'
import { getLinkAttrs } from '../../../lib/utils'
export default {
  name: 'MMobileNavItem',
  inheritAttrs: false,
  props: {
    /**
     * The HTML tag to render
     */
    tag: {
      type: [Object, String],
      default: 'a',
      validator: clickableTag,
    },
    /**
     * Whether this is the current nav item
     */
    active: {
      type: Boolean,
      default: false,
    },
    /**
     * Set to true if the child is a button
     */
    isButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    attrs() {
      return getLinkAttrs(this.$attrs, this.tag)
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../../sass/framework/mixins/hover';

.m-mobile-nav {
  &__item {
    border-bottom: 1px solid var(--skin-separator-color);

    &--active {
      border-left: 6px solid var(--color-primary-regular);
    }

    &--button {
      border: 0;
      padding: var(--spacing-24) var(--spacing-24);

      & ~ & {
        padding-top: 0;
      }
    }
  }

  &__link {
    @include hover.hover-transition(background-color);
    background: none;
    border: none;
    color: var(--skin-color);
    cursor: pointer;
    display: flex;
    font-size: var(--typography-paragraph-small-font-size);
    font-weight: var(--font-weight-bold);
    padding: calc(var(--spacing-24) - var(--spacing-4)) var(--spacing-24);
    text-decoration: none;
    width: 100%;

    @include hover.hover-styles {
      background-color: var(--skin-clickable-background-hover);
    }
  }
}
</style>
